/**
 * Global Color Tokens — mirrors the practitioner / user-web (Phyber Enterprise)
 * theme so all apps share one visual language.
 *
 * Prefer the semantic tokens (textPrimary, surfacePrimary, ...) in components.
 */

const Colors = {
  /* Brand */
  primaryBlue: "#4B61FF",
  primaryLightBlue: "#B3D7FF",
  primaryGreen: "#10B981",
  ctaBlue: "#0D62F8",
  ctaTeal: "#00B8AB",
  accentBlue: "#2563EB",

  /* Gradients */
  gradientPrimary: ["#2563EB", "#14B8A6"],
  ctaGradient: "linear-gradient(90deg, #0D62F8 0%, #00B8AB 100%)",
  sidebarGradient: "linear-gradient(to bottom, #172554, #022C22)", // blue-950 -> emerald-950
  loginBackgroundGradient:
    "linear-gradient(135deg, #e6faf5 0%, #f0f9ff 42%, #e0e7ff 100%)",

  /* Neutrals (slate) */
  white: "#FFFFFF",
  black: "#000000",
  gray900: "#0F172A",
  gray700: "#334155",
  gray500: "#64748B",
  gray300: "#CBD5E1",
  gray200: "#E2E8F0",
  gray100: "#F1F5F9",

  /* Backgrounds & surfaces */
  screenBackground: "#F8FAFC",
  surfacePrimary: "#FFFFFF",
  surfaceSecondary: "#F1F5F9",
  surfaceGlass: "rgba(255,255,255,0.60)",
  cardHeader: "#E7EDF5",

  /* Text */
  textPrimary: "#171717",
  textSecondary: "#334155",
  textTertiary: "#64748B",
  textDisabled: "#94A3B8",
  textInverse: "#FFFFFF",

  /* Borders */
  borderSubtle: "rgba(15,23,42,0.08)",
  borderGlass: "rgba(255,255,255,0.35)",

  /* Status */
  success: "#10B981",
  warning: "#F59E0B",
  error: "#DC2626",
  info: "#3B82F6",

  /* Accents */
  accentPurple: "#9333EA",
  accentOrange: "#F97316",
  accentTeal: "#14B8A6",
  accentEmerald: "#6EE7B7",

  /* Overlays */
  overlaySoft: "rgba(15,23,42,0.04)",
  overlayStrong: "rgba(15,23,42,0.12)",
  overlayDark: "rgba(0,0,0,0.45)",
};

export default Colors;
